export default {
  pageTitle: '微站 / 装修',
  manageTitle: '微站 / 装修',
  editorTitle: '页面装修',
  manageTip: '在此管理 H5 页面；点击「编辑页面」进入低代码装修。',
  manageHelpTitle: '说明',
  manageHelpDesc: '可新增多个 H5 页面并设置首页。在页面编辑器中点击「确定」保存后，访客可通过 pageId 链接访问。',
  backToPageList: '返回页面列表',
  editPage: '编辑页面',
  renamePage: '重命名',
  renameSuccess: '页面名称已更新',
  pageCreated: '页面已创建',
  pageRemoved: '页面已删除',
  setHomeSuccess: '已设为首页',
  pageNotFound: '页面不存在，已返回列表',
  previewHome: '预览首页',
  pagePreviewUrl: '本页链接',
  colTitle: '页面名称',
  colPageId: '页面 ID',
  colHome: '首页',
  colComponents: '组件数',
  colActions: '操作',
  paletteTitle: '组件库',
  pageListTitle: '页面',
  addPage: '新增页面',
  homeTag: '首页',
  setHome: '设为首页',
  removePage: '删除',
  propsTitle: '组件属性',
  groupBasic: '基础组件',
  groupLayout: '布局组件',
  groupRegistration: '报名组件',
  groupMeetingList: '会议组件',
  groupSpecial: '特殊组件',
  tabEdit: '编辑',
  tabPage: '页面',
  tabProps: '属性',
  pageStyleTitle: '页面设置',
  showComponent: '显示',
  dragSort: '拖动排序',
  canvasEffectTitle: '页面效果',
  selectNodeHint: '点击画布中的组件进行编辑',
  canvasTitle: '页面预览',
  canvasEmpty: '从左侧添加组件',
  preview: '预览',
  previewDialogTitle: '页面预览',
  previewDialogTip: '扫码或复制下方链接访问 H5 页面',
  copyPreviewLink: '复制链接',
  copyPreviewLinkSuccess: '链接已复制',
  copyPreviewLinkFailed: '复制失败，请手动复制',
  openPreviewInBrowser: '在浏览器中打开',
  previewUrl: '首页链接',
  saveSuccess: '已保存',
  saveFailed: '保存失败，请稍后重试',
  pageNamePrompt: '请输入页面名称',
  newPageDefaultName: '新页面',
  removePageConfirm: '确定删除该页面？',
  keepOnePage: '至少保留一个页面',
  deco: {
    tabDecor: '首页活动装修',
    tabPages: '功能页面列表',
    tabWeb: '活动网页装修',
    saveDeco: '保存装修',
    saveSuccess: '页面装修已保存',
    intro: '配置活动手机端展示页面：上传背景图 → 添加多个组件块（可排序）→ 指定每格跳转页面。',
    pagesIntro: '管理所有可用页面。内置页面直接关联系统功能，自定义页面可编辑标题与内容。配置好的页面将出现在首页活动装修的格子下拉选项中。',
    /** deco-studio 三栏工作台 */
    compPanel: '组件',
    layoutSection: '入口布局',
    basicSection: '基础组件',
    toolSection: '工具组件',
    compDisabledHint: '暂未开放，敬请期待',
    pageSettings: '页面设置',
    tabTitleBar: '标题栏',
    tabContent: '内容区',
    tabLogo: '底部 Logo',
    pageTitleLabel: '页面标题',
    showTitleLabel: '显示标题',
    titleColorLabel: '标题颜色',
    titleColorBlack: '深色',
    titleColorWhite: '浅色',
    bgColorLabel: '背景色',
    contentOffsetLabel: '内容区位置',
    contentOffsetHint: '向下偏移，让背景图顶部露出更多',
    quickAddLayout: '快速添加入口布局',
    layout1: '一大两小',
    layout2: '左右两列',
    layout3: '三列平铺',
    layout4: '整行入口',
    compCarousel: '轮播图',
    compSingleImage: '单图',
    compNav: '导航',
    compImageCube: '图片魔方',
    compInfoCard: '信息卡片',
    compButtonGroup: '按钮组',
    compTitle: '标题',
    compVideo: '视频',
    compMap: '地图',
    compNews: '资讯',
    compCountdown: '倒计时',
    compDivider: '分割线',
    compSpacer: '辅助空白',
    compNotice: '公告',
    compTextGroup: '文本组',
    compRichText: '富文本',
    compAlert: '提示条',
    compTimeline: '时间轴',
    compFloatBtn: '悬浮按钮',
    stepBg: '设置背景图',
    stepBgHint: '按 iPhone Pro Max 尺寸 1290×2796px（9:19.5），JPG/PNG，铺满活动手机页背景',
    stepBlocks: '添加组件块',
    stepBlocksHint: '可多次点击添加不同布局组件，拖拽排序决定显示先后顺序',
    stepEntry: '配置各块页面入口',
    stepEntryHint: '为每块的每个格子指定页面。在「功能页面列表」中可新增自定义页面',
    stepEntryNeedBlocks: '请先添加入口布局组件块',
    stepLogo: '底部 Logo 展示',
    stepLogoHint: '在手机页底部展示品牌 Logo，建议透明背景 PNG，宽度 400px 以上',
    footerLogoDefaultHint: '未上传时，所有页面（含内置报名/日程页）将使用系统默认 Logo。',
    footerLogoUsingDefault: '当前使用默认 Logo',
    saveFooterLogo: '保存 Logo',
    footerLogoUnsaved: '有未保存的修改',
    footerLogoUploadSuccess: 'Logo 已上传，请点击保存',
    footerLogoUploadFailed: 'Logo 上传失败',
    footerLogoSaveSuccess: '底部 Logo 已保存',
    footerLogoSaveFailed: '底部 Logo 保存失败',
    uploadLogoLockedHint: '上传自定义 Logo',
    uploadLogoLockedSub: '透明背景 PNG 效果最佳',
    logoLockTitle: '自定义底部 Logo · 会员专属权益',
    logoLockSubtitle: '当前套餐暂未包含此功能',
    logoLockDesc: '开通或升级会员套餐后即可解锁，将活动页底部的平台 Logo 替换为您的品牌标识，打造专属品牌形象。',
    logoLockFeat1: '上传自定义品牌 Logo（支持透明 PNG）',
    logoLockFeat2: '自定义 Logo 下方品牌说明文字',
    logoLockFeat3: '移除平台标识，凸显主办方品牌',
    logoLockCta: '🔓 开通 / 升级会员套餐，解锁自定义',
    logoLockFootnote: '请前往「会员套餐」升级含此权益的档位，或联系客服了解定制套餐',
    logoLockComingSoon: '请先开通含此权益的会员套餐',
    optional: '选填',
    uploaded: '✓ 已上传',
    uploadBg: '点击上传背景图',
    uploadLogo: '点击上传 Logo',
    replace: '更换',
    removeBg: '移除背景图',
    removeLogo: '移除 Logo',
    logoTextLabel: 'Logo 下方说明文字（选填）',
    logoTextPh: '例：© 2026 半度云科技 版权所有',
    blocksEmpty: '尚未添加任何组件块\n点击上方样式快速添加',
    blocksAdded: '已添加 {n} 块',
    blockIndex: '第{n}块',
    blockSlotCount: '{n} 个格子',
    tpl1: '一大两小',
    tpl2: '两列平铺',
    tpl3: '三列平铺',
    tpl4: '一行一个',
    slotLeftBig: '左侧大格',
    slotTopRight: '右上格',
    slotBottomRight: '右下格',
    slotLeft: '左格',
    slotCenter: '中格',
    slotRight: '右格',
    slotFullRow: '整行',
    slotDefault: '格{n}',
    slotEmpty: '（空格）',
    slotBg: '格{n} 底图',
    recommendSize: '推荐 {size}',
    entryNote: '💡 可在对应的按钮关联具体的功能页面；可在「功能页面列表」中进行装修，编辑相关的功能页面。',
    phonePreview: '📱 手机端预览',
    phoneEntrySub: '功能入口',
    phoneBlocksEmpty: '从左侧添加布局后在此预览',
    phoneSizeHint: '1290×2796px（iPhone Pro Max）\n多个组件块垂直堆叠展示',
    sectionHome: '首页',
    sectionBuiltin: '内置页面（{n}个）',
    sectionCustom: '自定义页面（{n}个）',
    homePageDefaultName: '首页',
    homePageDesc: '活动 H5 入口页，固定不可删除',
    homePageMissing: '暂无首页，请刷新或重新进入',
    customPageDesc: '可编辑标题与页面内容',
    customEmpty: '暂无自定义页面，点击「新增页面」创建',
    tagFixed: '固定页面',
    tagBuiltin: '内置',
    tagUnavailable: '开发中，不可用',
    tagCustom: '自定义',
    builtinDesc: '系统内置，不可装修；装修页可通过「点击动作」跳转至此',
    editHomeDeco: '装修首页',
    noHomePage: '请先创建首页',
    defaultActivityTitle: '活动名称',
    builtinReg: '报名页',
    builtinAgenda: '会议日程',
    builtinTasks: '任务查询',
    builtinSeat: '查座位',
    builtinHotel: '酒店安排',
    builtinCheckin: '签到页面',
    builtinProfile: '个人中心'
  },
  /** 活动网页装修 */
  web: {
    sectionHeader: '网页活动头版',
    sectionModules: '活动模块配置',
    headerTitle: '活动网页头版配置',
    headerDesc: '配置活动网页头版所需的视觉素材：上传活动海报、分页背景底图、活动举办方 Logo 与导航栏图片，将用于生成对外活动网页。功能入口请在「活动模块配置」中绑定。',
    shareEvent: '分享活动',
    previewPage: '预览页面',
    enabled: '已启用',
    disabled: '未启用',
    posterTitle: '活动海报',
    posterLabel: '对外展示的主视觉海报（头版图）',
    posterHint: '建议分辨率：16:9 横版，2560×1440，JPG / PNG',
    backgroundTitle: '分页背景底图',
    backgroundLabel: '各内容分页共用的背景底图',
    backgroundHint: '建议分辨率：16:9 横版，2560×1440，JPG / PNG',
    logoTitle: '活动举办方 Logo',
    logoLabel: '主办方标识，展示于头版与页脚',
    logoHint: '建议分辨率：1:1 正方形，建议透明背景 PNG',
    navTitle: '导航栏图片',
    navLabel: '活动网页顶部导航栏的整条背景图，用于承载导航栏目与品牌视觉',
    navHint: '建议分辨率：1457 × 70 px（长条形），JPG / PNG',
    uploadHint: '点击上传图片',
    uploadFormat: 'JPG / PNG',
    replace: '更换图片',
    urlPlaceholder: '或填写图片 URL',
    modulesIntro: '已绑定 {n} 个功能页面（含内置与自定义页面），绑定的页面将作为活动网页的入口展示。',
    modulesAdd: '新增创建',
    modulesEmpty: '尚未绑定任何页面，点击右上角「+ 新增创建」绑定功能页面列表中的页面。',
    moduleDialogTitle: '绑定功能页面',
    moduleDialogTip: '选择要展示在活动网页中的功能页面。',
    moduleDialogDone: '完成',
    moduleBind: '绑定',
    moduleBound: '已绑定',
    moduleBoundShort: '已绑定',
    moduleBuiltinTag: '内置',
    moduleCustomTag: '自定义',
    moduleUnavailable: '开发中',
    buttonImage: '按钮图片',
    buttonImageSpec: '(分辨率 355×86 px)',
    buttonImageUpload: '点击上传按钮图片',
    buttonImageHint: '作为活动网页中该模块的入口按钮图，建议 355×86 px，透明背景 PNG 效果更佳。',
    unbind: '解绑',
    moduleBuiltinGroup: '内置页面',
    moduleCustomGroup: '自定义页面',
    moduleNoPages: '暂无可绑定的功能页面',
    moduleBuiltin: '内置页面',
    moduleCustom: '自定义页面',
    remove: '移除',
    moveUp: '上移',
    moveDown: '下移',
    uploadSuccess: '图片上传成功',
    uploadFailed: '图片上传失败，请稍后重试',
    loadFailed: '网页配置加载失败',
    saveFailed: '保存失败，请稍后重试',
    previewUnavailable: '暂无可预览的活动页面'
  },
  /** 全局模板 */
  importFromTemplate: '从模板导入',
  saveAsTemplate: '生成模板',
  quickCreateTitle: '快速创建',
  quickCreateRecommended: '为你推荐',
  quickCreatePresetPending: '该页面模板筹备中，请先从下方推荐模板选择',
  quickCreateBlankDefaultName: '空白页',
  quickCreate: {
    home: '会务首页',
    register: '报名页',
    meetingList: '会议列表',
    meetingDetail: '会议详情',
    intro: '活动介绍',
    seat: '座位查询',
    photoLive: '照片直播',
    contact: '联系我们',
    blank: '空白'
  },
  templateDialogTitle: '从模板导入',
  templateSaveDialogTitle: '保存为全局模板',
  templatePresetLabel: '页面类型',
  templatePresetHint: '将当前活动中的一页保存为全局模板，覆盖「从模板导入」顶部对应快捷项。',
  templatePresetHintOther: '保存后仅出现在「为你推荐」模板列表（顶部快捷项绑定的模板不会出现在推荐区）；分类可留空。',
  templatePresetRequired: '请选择页面类型',
  templatePresetPageNotFound: '未找到可保存的页面（活动内仅保留一页时可直接保存；多页时请保留对应类型的一页）',
  templatePreset: {
    other: '其它'
  },
  templateKeyReadonlyHint: '与快捷创建项绑定，不可修改',
  templateKeyCustomHint: '自定义代号，仅用于推荐模板导入',
  templateCategoryEmptyPlaceholder: '留空',
  templateSelectHint: '选择模板后将页面追加到当前活动（保留已有页面）。',
  templateColName: '模板名称',
  templateColKey: '模板代号',
  templateColPages: '页数',
  templateColCover: '封面',
  templateImportConfirm: '导入模板',
  templateImportSuccess: '模板已导入',
  templateImportSuccessCount: '已导入 {n} 个页面',
  templateImportFailed: '模板导入失败，请稍后重试',
  templateSaveSuccess: '已保存为全局模板',
  templateOverwriteSuccess: '模板已覆盖更新',
  templateSaveFailed: '保存模板失败，请稍后重试',
  templateEmptyPages: '当前活动没有微站页面，无法保存为模板',
  templateNoContent: '当前微站页面均为空，请至少装修一页后再保存',
  templateKeyLabel: '模板代号',
  templateKeyPlaceholder: '如 conference_standard_v1（小写英文、数字、下划线）',
  templateKeyRequired: '请填写模板代号',
  templateKeyInvalid: '模板代号格式不正确（小写英文、数字、下划线，2–63 位）',
  templateNameLabel: '模板名称',
  templateNamePlaceholder: '如：标准会务微站',
  templateNameRequired: '请填写模板名称',
  templateDescLabel: '模板简介',
  templateCoverLabel: '封面 URL',
  templateCoverPlaceholder: 'https://...',
  templateCategoryLabel: '分类',
  templateOverwriteConfirm: '模板代号「{key}」已存在，是否覆盖更新？',
  templateNoList: '暂无可用模板',
  moveUp: '上移',
  moveDown: '下移',
  removeNode: '删除组件',
  dragToDelete: '拖到此处删除',
  dragToDeleteHint: '在画布中按住 ⋮⋮ 拖动排序；拖到手机下方删除区可删除组件',
  actionNone: '无动作',
  actionNavigate: '跳转页面',
  actionLink: '打开链接-内嵌',
  actionExternalLink: '打开链接',
  allowBrowserOpen: '是否允许在浏览器中打开',
  embeddedLinkBack: '返回',
  embeddedLinkHint: '若页面无法显示，请点击右上角的在浏览器中打开。',
  embeddedLinkInvalid: '链接无效，仅支持 HTTP 或 HTTPS 网页地址。',
  embeddedLinkConfigHint: '在活动页面内打开；部分外部网站可能不支持内嵌。',
  actionPhone: '拨打电话',
  actionPreviewImage: '弹出图片',
  actionSeatQuery: '座位查询',
  seatQueryPageUnnamed: '未命名查询页',
  seatQueryPagesEmpty: '暂无已保存的座位查询页，请先在「座位编辑」中创建并保存',
  builtinRegMissing: '活动尚未绑定报名问卷，无法打开报名页',
  builtinRegMissingHint: '请先在「报名设置」中绑定已发布的问卷',
  builtinRegActivityMissing: '缺少活动信息，无法打开报名页',
  builtinAgendaMissing: '缺少活动信息，无法打开会议日程',
  builtinTasksMissing: '缺少活动信息，无法打开任务查询',
  components: {
    text: '文本',
    image: '图片',
    carousel: '轮播图',
    imageCube: '图片魔方',
    button: '按钮',
    spacer: '空白',
    divider: '分割线',
    floatButton: '悬浮按钮',
    registrationForm: '问卷表单',
    meetingAgenda: '会议日程',
    meetingList: '会议列表'
  },
  registrationFormOnlyOnRegistrationPage: '问卷仅可在「快速创建-报名页」中使用',
  meetingListOnlyOnMeetingListPage: '会议列表仅可在「快速创建-会议列表」中使用',
  meetingListSingleOnly: '本页已添加会议日程组件，每页最多一个',
  meetingListRequired: '请添加会议列表组件后再保存',
  meetingListEditorHint: '编辑器仅占位展示；H5 将拉取活动下全部会议并以卡片展示。',
  meetingListPropsHint: '保存后可在 H5 预览；各会议跳转在下方列表中配置。',
  meetingListEmpty: '暂无会议',
  meetingListNoActivity: '未关联活动，无法加载会议',
  meetingListLoadFailed: '会议列表加载失败，请稍后重试',
  meetingListActivityNotFound: '活动不存在或已下线',
  meetingListCardGap: '卡片间距 (px)',
  meetingListActionsTitle: '会议跳转设置',
  meetingListActionsHint: '拉取当前活动会议列表后，可为每条会议单独配置点击跳转（跳转微站页面时自动携带 meetingId）。',
  meetingListActionsRefresh: '刷新列表',
  meetingListActionsLoading: '加载中…',
  meetingListActionsEmpty: '暂无会议，请先在「会议日程」中维护',
  meetingListActionsNoActivity: '缺少活动 ID，无法加载会议',
  meetingListFieldStart: '开始',
  meetingListExpandCard: '展开日程',
  meetingListCollapseCard: '折叠日程',
  meetingListExpandIntro: '展开简介',
  meetingListCollapseIntro: '收起简介',
  meetingListExpand: '展开',
  meetingListCollapse: '收起',
  meetingListFieldEnd: '结束',
  meetingListFieldRegion: '区域',
  meetingListFieldAddress: '地址',
  meetingListFieldLocation: '地点',
  meetingListFieldIntro: '简介',
  specialComponentCannotRemove: '该组件为系统特殊组件，不可删除',
  registrationFormSingleOnly: '本页已添加问卷组件，每页最多一个',
  registrationFormNeedActivityBind: '当前活动未绑定报名表，请先在活动设置中关联后再添加',
  registrationFormBoundToActivityHint: '固定使用当前活动已关联的报名表，不可更换',
  registrationFormRequired: '请选择已发布的问卷后再保存',
  registrationMeetingRequired: '请选择所属会议后再保存',
  registrationMeetingSelectLabel: '所属会议',
  registrationMeetingSelectPlaceholder: '选择会议场次',
  registrationMeetingSelectHint: '可选：在右侧选择该报名页对应的会议场次',
  registrationMeetingSelected: '所属会议',
  registrationFormSelectLabel: '关联问卷',
  registrationFormSelectPlaceholder: '选择已发布的问卷',
  registrationFormSelectHint: '请在右侧属性中选择已发布的问卷',
  registrationFormSelected: '已选问卷',
  registrationFormHideTitle: '隐藏问卷标题',
  registrationFormEditFieldsHint: '字段内容请在「报名管理 → 问卷设计器」中编辑',
  registrationFormNotConfigured: '未配置问卷',
  fields: {
    content: '文字内容',
    fontSize: '字号',
    color: '颜色',
    align: '对齐',
    alignLeft: '左对齐',
    alignCenter: '居中',
    alignRight: '右对齐',
    alignJustify: '左右对齐',
    imageUrl: '图片地址',
    imageUrlPh: 'https://... 或选择上传',
    pickImage: '选择图片',
    clearImage: '清除图片',
    noImage: '暂无图片',
    imagePending: '待保存上传',
    imageWidthPercent: '图片大小 (%)',
    height: '高度',
    carouselSlides: '幻灯片',
    addSlide: '添加幻灯片',
    slideIndex: '幻灯片 {n}',
    removeSlide: '删除',
    carouselSlideCount: '共 {n} 张幻灯片（请在「属性」中编辑）',
    carouselAutoplay: '自动播放',
    carouselInterval: '切换间隔（毫秒）',
    carouselIndicator: '显示指示点',
    carouselLoop: '循环播放',
    imageCubeLayout: '布局方式',
    imageCubeCols2: '两列',
    imageCubeCols3: '三列',
    imageCubeCols4: '四列',
    imageCubeMagic: '魔方布局',
    imageCubeMagic2: '魔方布局2',
    imageCubeImages: '图片列表',
    imageCubeGap: '图片间距',
    imageCubeGapX: '横向间距',
    imageCubeGapY: '纵向间距',
    imageCubeItemScale: '图片大小(%)',
    imageCubeItemScaleHint: '放大某一格时其它格相对让位，整体不超出魔方外框',
    imageCubeSummary: '{layout} · 共 {n} 张（请在「属性」中编辑）',
    imageCubeMagicSlot1: '魔方 · 左侧大图',
    imageCubeMagicSlot2: '魔方 · 右上',
    imageCubeMagicSlot3: '魔方 · 右下左',
    imageCubeMagicSlot4: '魔方 · 右下右',
    imageCubeMagic2Slot1: '魔方2 · 左侧',
    imageCubeMagic2Slot2: '魔方2 · 右上',
    imageCubeMagic2Slot3: '魔方2 · 右下',
    addImage: '添加图片',
    removeImage: '删除图片',
    imageIndex: '图片 {n}',
    borderRadius: '圆角',
    buttonText: '按钮文字',
    buttonPositionMode: '位置',
    buttonPositionFlow: '跟随文档流',
    buttonPositionFixed: '固定位置',
    buttonPositionFixedHint: '固定于全屏视口，不随页面滚动；编辑器内相对手机画布预览。',
    buttonPositionAnchor: '锚点',
    buttonOffsetX: '水平边距 (px)',
    buttonOffsetY: '垂直边距 (px)',
    buttonTextColor: '文字颜色',
    buttonWidthPercent: '宽度 (%)',
    buttonAnchor: {
      bottom_right: '右下',
      bottom_left: '左下',
      top_right: '右上',
      top_left: '左上',
      bottom_center: '底部居中',
      top_center: '顶部居中',
      center: '屏幕居中'
    },
    bgColor: '背景色',
    pageBackground: '背景图片',
    pageBackgroundHint: '铺满页面背景，保存后上传至 OSS；H5 预览与正式访问均生效。',
    pageBackgroundColor: '背景颜色',
    pageBackgroundColorPh: '#ffffff',
    actionType: '点击动作',
    targetPage: '目标页面',
    targetPagePlaceholder: '选择跳转页面',
    seatQueryPage: '座位查询页',
    seatQueryPagePlaceholder: '选择座位查询页',
    builtinPageGroup: '系统内置',
    customPageGroup: '自定义页面',
    linkUrl: '链接地址',
    phoneNumber: '电话号码',
    phoneNumberPh: '例如 13800138000 或 400-xxx-xxxx',
    phoneNumberHint: '访客在手机端点击后将拉起系统拨号；请填写可拨打的号码。',
    previewImageHint: '点击展示图时弹出此图（可与展示图不同；仅 H5 生效）',
    pageTitle: '页面名称',
    marginSection: '外边距',
    marginX: '左右边距',
    marginY: '上下边距',
    dividerColor: '线条颜色',
    dividerHeight: '线条粗细',
    floatButtonHint: '固定悬浮在页面右下角，不占用文档流位置',
    floatButtonHintShort: '固定右下角悬浮',
    floatButtonImageMode: '已上传图片，将替代文字按钮样式',
    floatImageWidth: '图片宽度',
    floatImageHeight: '图片高度',
    floatOffsetRight: '距右侧',
    floatOffsetBottom: '距底部'
  }
}
